"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtcTestnetAddressBasedDetector = void 0;
const types_1 = require("@requestnetwork/types");
const address_based_1 = require("./address-based");
const TESTNET_BITCOIN_NETWORK_ID = 3;
/**
 * Handle payment networks with testnet BTC based address extension
 *
 * @class PaymentNetworkBTCAddressBased
 */
class BtcTestnetAddressBasedDetector extends address_based_1.BtcAddressBasedDetector {
    /**
     * @param advancedLogic Instance of Advanced Logic layer, to get the extension
     */
    constructor({ advancedLogic, bitcoinDetectionProvider, }) {
        super(TESTNET_BITCOIN_NETWORK_ID, types_1.ExtensionTypes.PAYMENT_NETWORK_ID.TESTNET_BITCOIN_ADDRESS_BASED, advancedLogic.extensions.addressBasedTestnetBtc, bitcoinDetectionProvider);
    }
}
exports.BtcTestnetAddressBasedDetector = BtcTestnetAddressBasedDetector;
